import React, { useState, useContext, useEffect } from "react";
import {
  TextField,
  Box,
  Button,
  Paper,
  Typography,
  MenuItem,
  InputLabel,
  Grid,
  FormControl,
  Select,
  InputAdornment,
  IconButton,
  Chip,
  Autocomplete,
  Switch,
  Stack,
} from "@mui/material";
import { isEmpty, uniqBy } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSave,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";
import { DataContext } from "../../../context/DataContext";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { getRolListAsync } from "../../../api/Rols";
import {
  addUserAsync,
  addUserWithSucursalsAsync,
  getJefesListAsync,
  getSucursalByUserAsync,
} from "../../../api/Users";
import BackButton from "../../../components/ui/BackButton";

const tituloPantallaSx = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 600,
  fontSize: 16.5,
  color: "text.primary",
  lineHeight: 1.1,
};

// Titulo de cada tarjeta de seccion, igual que en Detalle de credito.
const tituloTarjetaSx = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 600,
  fontSize: 16,
  color: "text.primary",
  marginBottom: "18px",
};

const AddUser = () => {
  const token = getToken();
  let ruta = getRuta();
  let navigate = useNavigate();
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);

  const [showPassword, setShowPassword] = useState(false);

  const [rolesList, setRolesList] = useState([]);
  const [jefeList, setJefeList] = useState([]);

  const [selectedRol, setSelectedRol] = useState("");
  const [selectedJefe, setSelectedJefe] = useState("");

  const [firstName, setFirstName] = useState("");
  const [secondName, setSecondName] = useState("");
  const [lastName, setLastName] = useState("");
  const [secondLastName, setSecondLastName] = useState("");

  const [userName, setUserName] = useState("");
  const [passWord, setPassWord] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");

  //Controladores de Sucursales
  const [allSucursals, setAllSucursals] = useState(false);

  const [sucursalList, setSucursalList] = useState([]);
  const [value, setValue] = useState([]);

  useEffect(() => {
    getRoles();
    getSucursals();
  }, []);

  const getSucursals = async () => {
    setIsLoading(true);
    const result = await getSucursalByUserAsync(token);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }
    setSucursalList(result.data.result);
    setIsLoading(false);
  };

  const getRoles = async () => {
    setIsLoading(true);
    const result = await getRolListAsync(token);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    setRolesList(result.data.result);
  };

  const handleChangeRol = async (event) => {
    let selected = event.target.value;
    setSelectedJefe("");
    setSelectedRol(selected);
    const result = await getJefesListAsync(token, selected);
    if (!result.statusResponse) {
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    setJefeList(result.data.result);
    setIsLoading(false);
  };

  const addNewUser = async () => {
    if (validate()) {
      allSucursals ? saveToAllSucursals() : saveWithSucursals();
    }
  };

  const validate = () => {
    let isValid = true;
    if (isEmpty(firstName)) {
      simpleMessage("Debe ingresar un nombre", "error");
      return (isValid = false);
    }

    if (isEmpty(lastName)) {
      simpleMessage("Debe ingresar un apellido", "error");
      return (isValid = false);
    }

    if (selectedJefe === "") {
      if (selectedRol !== 2) {
        simpleMessage("Debe seleccionar un puesto de trabajo", "error");
        return (isValid = false);
      }
    }

    if (isEmpty(userName)) {
      simpleMessage("Debe ingresar usuario de acceso", "error");
      return (isValid = false);
    }

    if (isEmpty(passWord)) {
      simpleMessage("Debe ingresar una contraseña", "error");
      return (isValid = false);
    }
    if (passWord.length < 6) {
      simpleMessage(
        "Debe ingresar una contraseña mayor de 6 caracteres",
        "error"
      );
      return (isValid = false);
    }
    if (isEmpty(confirmPassword)) {
      simpleMessage("Debe confirmar su contraseña", "error");
      return (isValid = false);
    }

    if (passWord !== confirmPassword) {
      simpleMessage("La confirmacion de contraseña no coincide", "error");
      return (isValid = false);
    }

    if (selectedRol === "") {
      simpleMessage("Debe seleccionar un rol de usuario", "error");
      return (isValid = false);
    }
    if (isEmpty(phone)) {
      simpleMessage("Debe ingresar un numero telefonico", "error");
      return (isValid = false);
    }

    if (isEmpty(value.filter((s) => s.id !== undefined))) {
      simpleMessage("Debe asignar al menos una sucursal", "error");
      return (isValid = false);
    }
    return isValid;
  };

  const clearData = () => {
    setFirstName("");
    setSecondName("");
    setLastName("");
    setSecondLastName("");
    setPhone("");
    setAddress("");
    setSelectedRol("");
    setSelectedJefe("");
    setUserName("");
    setPassWord("");
    setConfirmPassword("");
    setValue([]);
  };

  const saveToAllSucursals = async () => {
    const datos = {
      firstName,
      secondName,
      lastName,
      secondLastName,
      userName,
      passWord,
      phone,
      address,
      supervisorId: selectedJefe === "" ? selectedRol : selectedJefe,
      idRole: selectedRol,
    };
    setIsLoading(true);
    const result = await addUserAsync(token, datos);
    if (!result.statusResponse) {
      setIsLoading(false);

      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }

      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    clearData();
    simpleMessage("Usuario Agregado...!", "success");
  };

  const saveWithSucursals = async () => {
    const filtered = value.filter((s) => s.id !== undefined);
    const datos = {
      firstName,
      secondName,
      lastName,
      secondLastName,
      userName,
      passWord,
      phone,
      address,
      supervisorId: selectedJefe === "" ? selectedRol : selectedJefe,
      idRole: selectedRol,
      sucursales: filtered,
    };
    setIsLoading(true);
    const result = await addUserWithSucursalsAsync(token, datos);
    if (!result.statusResponse) {
      setIsLoading(false);

      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }

      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    clearData();
    simpleMessage("Usuario Agregado...!", "success");
  };

  return (
    <div>
      {/* Sin Container: el layout del shell ya define ancho y padding. */}
      <Stack spacing={2.5}>
        <Paper sx={{ padding: "18px 22px" }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <BackButton onClick={() => navigate(`${ruta}/users`)} />
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={tituloPantallaSx}>Agregar usuario</Typography>
              <Typography
                sx={{ fontSize: 13, color: "text.disabled", marginTop: "3px" }}
              >
                Registrar un nuevo usuario del sistema
              </Typography>
            </Box>
          </Stack>
        </Paper>

        <Paper sx={{ padding: "22px" }}>
          <Typography sx={tituloTarjetaSx}>Datos del Usuario</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <TextField
                  required
                  fullWidth
                  onChange={(e) => setFirstName(e.target.value.toUpperCase())}
                  value={firstName}
                  label={"Primer Nombre"}
                />

                <TextField
                  fullWidth
                  onChange={(e) => setSecondName(e.target.value.toUpperCase())}
                  value={secondName}
                  label={"Segundo Nombre"}
                />
                <TextField
                  required
                  fullWidth
                  onChange={(e) => setLastName(e.target.value.toUpperCase())}
                  value={lastName}
                  label={"Primer apellido"}
                />
                <TextField
                  fullWidth
                  onChange={(e) =>
                    setSecondLastName(e.target.value.toUpperCase())
                  }
                  value={secondLastName}
                  label={"Segundo Apellido"}
                />

                <TextField
                  fullWidth
                  required
                  onChange={(e) => setPhone(e.target.value.toUpperCase())}
                  value={phone}
                  label={"Telefono"}
                />
              </Stack>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Stack spacing={2}>
                <TextField
                  required
                  fullWidth
                  onChange={(e) => setUserName(e.target.value.toLowerCase())}
                  value={userName}
                  label={"Usuario"}
                />

                <TextField
                  required
                  fullWidth
                  onChange={(e) => setPassWord(e.target.value)}
                  value={passWord}
                  label={"Contraseña"}
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          aria-label="toggle password visivility"
                        >
                          {showPassword ? (
                            <FontAwesomeIcon
                              icon={faEye}
                              style={{ color: "#105155" }}
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faEyeSlash}
                              style={{ color: "#105155" }}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  required
                  fullWidth
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  value={confirmPassword}
                  label={"Confirmar contraseña"}
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          aria-label="toggle password visivility"
                        >
                          {showPassword ? (
                            <FontAwesomeIcon
                              icon={faEye}
                              style={{ color: "#105155" }}
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faEyeSlash}
                              style={{ color: "#105155" }}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <FormControl fullWidth required>
                  <InputLabel id="demo-simple-select-standard-label">
                    Seleccione un rol
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={selectedRol}
                    onChange={handleChangeRol}
                    label="Rol de usuario"
                    style={{ textAlign: "left" }}
                  >
                    <MenuItem value="">
                      <em>Seleccione un rol de usuario</em>
                    </MenuItem>
                    {rolesList.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.rolName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <FormControl fullWidth required>
                  <InputLabel id="demo-simple-select-standard-label">
                    Jefe Inmediato
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={selectedJefe}
                    onChange={(e) => setSelectedJefe(e.target.value)}
                    label="Jefe Inmediato"
                    style={{ textAlign: "left" }}
                  >
                    <MenuItem value="">
                      <em>Seleccione un Jefe Inmediato</em>
                    </MenuItem>
                    {jefeList.map((item) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.fullName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Stack>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                onChange={(e) => setAddress(e.target.value.toUpperCase())}
                value={address}
                label={"Direccion"}
              />
            </Grid>

            <Grid item xs={12}>
              <Stack
                spacing={2}
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
              >
                <Typography
                  sx={{ ...tituloTarjetaSx, fontSize: 14.5, marginBottom: 0 }}
                >
                  Acceso a Todas las Sucursales
                </Typography>

                <Switch
                  color={allSucursals ? "success" : "error"}
                  checked={allSucursals}
                  onChange={() => setAllSucursals(!allSucursals)}
                />
              </Stack>

              {allSucursals ? (
                <></>
              ) : (
                <Autocomplete
                  multiple
                  id="fixed-tags-demo"
                  value={value}
                  onChange={(event, newValue) => {
                    setValue(uniqBy(newValue, "id"));
                  }}
                  options={sucursalList}
                  getOptionLabel={(option) => option.description}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        label={option.description}
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Sucursales"
                      placeholder="Acceso a Sucursales"
                    />
                  )}
                />
              )}
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<FontAwesomeIcon icon={faSave} />}
                onClick={() => addNewUser()}
                sx={{ height: 46, paddingX: 2.5 }}
              >
                Agregar usuario
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Stack>
    </div>
  );
};

export default AddUser;
